import type { PayloadAction } from "@reduxjs/toolkit";
import { DUMMY_IMAGE_SETTINGS } from "Data/Dummy/Camera";
import { createAppSlice } from "Data/Redux/Store";
import type { ImageSettingsState } from "Interfaces";

export const setImageReducer = (state: ImageSettingsState, action: PayloadAction<ImageSettingsState>) => {
	return action.payload;
};

export const getImage = (state: ImageSettingsState) => {
	return state;
};

const imageSlice = createAppSlice({
	name: "image",
	initialState: DUMMY_IMAGE_SETTINGS,
	reducers: {
		setImageAction: setImageReducer
	},
	selectors: {
		selectImage: getImage
	}
});

export default imageSlice;

export const { setImageAction } = imageSlice.actions;
export const { selectImage } = imageSlice.selectors;
